import React, { Suspense } from 'react';
import gql from 'graphql-tag';
import { ApolloProvider, useQuery } from '@apollo/client';
import Content from './Content';
import ReactDOM from 'react-dom';
const QUERY = gql `
  query ContentLoaderQuery($tag: String) {
    content(tag: $tag)
  }
`;
const ContentLoader = (props) => {
    let { loading, error, data, refetch, fetchMore } = useQuery(QUERY, {
        variables: {
            tag: props.tag,
        },
    });
    if (error)
        return React.createElement("div", null, error.message);
    if (loading)
        return React.createElement(React.Fragment, null);
    return React.createElement(Content, { content: data.content });
};
export default ContentLoader;
const renderContent = (apolloClient) => {
    let contentElements = document.getElementsByClassName('aperza-content');
    if (contentElements) {
        let elementsArray = Array.from(contentElements);
        elementsArray.forEach((element) => {
            ReactDOM.render(React.createElement(ApolloProvider, { client: apolloClient },
                React.createElement(Suspense, { fallback: React.createElement("div", null) },
                    React.createElement(ContentLoader, { tag: element.getAttribute('data-tag') }))), element);
        });
    }
};
export { renderContent };
